import Button from '@ingka/button';
import SSRIcon from '@ingka/ssr-icon';
import checkmarkCirclePath from '@ingka/ssr-icon/paths/checkmark-circle';
import Text from '@ingka/text';
import { useNavigate, useSearchParams } from 'react-router';
import AppFooter from '@/components/layout/AppFooter';
import AppHeader from '@/components/layout/AppHeader';
import styles from './LocationsSuccessPage.module.css';

export default function LocationsSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const countParam = searchParams.get('count');
  const count = countParam ? parseInt(countParam, 10) : 0;
  const validCount = Number.isFinite(count) && count > 0 ? count : 1;

  const locationLabel = validCount === 1 ? 'location' : 'locations';

  return (
    <>
      <AppHeader />
      <main className={styles.main}>
        <div className={styles.card}>
          <div className={styles.iconWrap}>
            <SSRIcon paths={checkmarkCirclePath} />
          </div>

          <Text tagName="h1" textStyle="Heading.L" className={styles.title}>
            {validCount} {locationLabel} uploaded
          </Text>

          <Text tagName="p" textStyle="Body.L" className={styles.subtitle}>
            Your submission was received. The data will be processed by Databricks shortly.
          </Text>

          <div className={styles.actions}>
            <Button
              type="emphasised"
              text="Add more locations"
              onClick={() => navigate('/locations')}
            />
            <Button type="secondary" text="Go to archive" onClick={() => navigate('/archive')} />
          </div>
        </div>
      </main>
      <AppFooter />
    </>
  );
}
